const { IntlProvider } = require('react-intl');
const config = require('../config');
const commonHelper = require('../helper/common-helper');
import fetchHelper from '../helper/fetch-helper';
// const Sentry = require('@sentry/browser');
const Cookies = require('js-cookie');

let intl = null;
exports.initSingletonIntl = function({ locale, messages = {} }) {
  const intlProvider = new IntlProvider({ locale, messages });

  intl = intlProvider.getChildContext().intl;
  return intl;
};

exports.formatMessage = function(...args) {
  if (!intl) {
    // throw new Error('intl instance must be initialized before using it');
    return 'Intl is not yet initialized.';
  }
  let text = '';

  try {
    text = intl.formatMessage(...args);
  } catch (e) {
    text = args.backup || '';
    // Sentry.captureException(e);
  }

  return text;
};

exports.getIntl = function() {
  return intl;
};

function loadCurrencyCSS(currency) {
  const style = document.createElement('style');

  style.textContent = `
    .price::before {
      content: "${currency}";
    }

    .discount::before {
      content: "-${currency}";
    }
  `;

  document.body.appendChild(style);
}

exports.getShopBaseConf = function(loadFunc, applicationName) {
  const shopId = commonHelper.getUrlParam('shopId');
  sessionStorage.setItem('currency', '');
  fetchHelper
    .get(`${config.getShopBaseConfAPI}?shopId=${shopId}`, null, { enableDefaultResponseResolve: false })
    .then((response = {}) => {
      const res = response.data;
      let currency = '';
      let locale = 'zh_CN';
      // 读取本地用户设置
      const localLanguageSwitch = sessionStorage.getItem('language_switch');

      if (res && res.code === '200' && res.data) {
        console.log('res.data', res.data);
        const {
          brandLanguageDefault = locale,
          brandLanguages = [],
          dateFormat,
          dinningForm,
          languageSwitch = false,
          currencySymbol,
          showSaleNum = false,
          brandId = '',
          commercialName = '',
          userProtocal = '',
          privacyProtocal = '',
          protocalStatus = 0,
        } = res.data;
        currency = currencySymbol;
        sessionStorage.setItem('currency', currency);
        sessionStorage.setItem('dateFormat', dateFormat);
        sessionStorage.setItem('diningForm', dinningForm); // 注意这里的 dinningForm，后端字段拼写错误多了一个n
        sessionStorage.setItem('showSaleNum', showSaleNum); // 是否开启了商品余量展示开关
        sessionStorage.setItem('brandId', brandId);
        sessionStorage.setItem('commercialName', commercialName);
        sessionStorage.setItem('userProtocal', userProtocal); // 后端返回的自定义用户协议
        sessionStorage.setItem('privacyProtocal', privacyProtocal); // 后端返回的自定义隐私协议
        sessionStorage.setItem('protocalStatus', protocalStatus);
        if (brandLanguages.length === 0) {
          brandLanguages.push(brandLanguageDefault); // 容错处理
        }
        // 将语言写入cookie
        const cookieLanguage = Cookies.get(`language_switch_${brandId}`);
        if (!cookieLanguage || cookieLanguage === 'undefined' || cookieLanguage === 'null' || !brandLanguages.includes(cookieLanguage) || !languageSwitch) {
          Cookies.set(`language_switch_${brandId}`, brandLanguageDefault, { expires: 90 }); // 90天有效期
        }
        const localBrandLanguages = sessionStorage.getItem('brandLanguages');
        locale = Cookies.get(`language_switch_${brandId}`) || brandLanguageDefault; // 如果重新写入了cookie或者用户修改过，需要重新读取
        // 如果语言开关开启
        if (languageSwitch.toString() !== localLanguageSwitch) {
          sessionStorage.setItem('language_switch', languageSwitch);
        }

        if (localBrandLanguages !== brandLanguages.join(',')) {
          sessionStorage.setItem('brandLanguages', brandLanguages.join(','));
        }
      }
      loadCurrencyCSS(currency);
      sessionStorage.setItem('locale', locale);
      loadFunc(locale);
    })
    .catch(() => {
      sessionStorage.setItem('currency', '');
    });
};



// WEBPACK FOOTER //
// ./src/intl/helper.js